import React, { useRef, useState, useEffect } from "react";
import GlobalSearch from "../Search/GlobalSearch";
import Function from "../../../lib/functions";

// import $ from 'jquery';
import { useStaticQuery, graphql, Link } from "gatsby";

/**Images */
import jameelMotorsLogo from "../../../common/images/Global/header/jameelMotorsLogoOld.svg";
import jameelMotorsLogoBlue from "../../../common/images/Global/header/jameelMotorsLogoBlueOld.svg";
import earth from "../../../common/images/Global/header/earth.svg";
// import earthBlue from "../../../common/images/Global/header/earthBlue.svg";
// import location from "../../../common/images/Global/header/location.svg";
import search from "../../../common/images/Global/header/search.svg";
import searchBlue from "../../../common/images/Global/header/searchBlue.svg";
import burgerIcon from "../../../common/images/Global/header/burgerIcon.svg";
// import menuClose from "../../../common/images/Global/header/menuClose.svg";
import closeBlue from "../../../common/images/Global/header/closeBlue.svg";
import menuBlue from "../../../common/images/Global/header/menuBlue.svg";
import rightArrowWhite from "../../../common/images/Homepage/newsAndInsights/rightArrowWhite.svg";
import LangConfig from "../../LangConfig/LangConfig.json";

export default function Header(props) {
  /**HTML element references */
  const navMenuRef = useRef();
  const burgerMenuIconRef = useRef();

  // console.log(props, "props data to show here please");


  const flatListToHierarchical = (
    data = [],
    { idKey = "id", parentKey = "parentId", childrenKey = "children" } = {}
  ) => {
    const tree = [];
    const childrenOf = {};
    data.forEach((item) => {
      const newItem = {
        ...item,
      };
      const { [idKey]: id, [parentKey]: parentId = 0 } = newItem;
      childrenOf[id] = childrenOf[id] || [];
      newItem[childrenKey] = childrenOf[id];
      parentId
        ? (childrenOf[parentId] = childrenOf[parentId] || []).push(newItem)
        : tree.push(newItem);
    });
    return tree;
  };

  const menuqry = useStaticQuery(graphql`
  
    {
      menuEn: wpMenu(name: { eq: "Top Navigation" }) {
        menuItems {
          nodes {
            label
            parentId
            url
            id
            databaseId
          }
        }
      }

      menuAr:  wpMenu(name: {eq: "Top Navigation AR"}) {
        menuItems {
          nodes {
            label
            parentId
            url
            id
            databaseId
          }
        }
    }

    menuZhcn:  wpMenu(name: {eq: "Top Most Menu ZHCN"}) {
      menuItems {
        nodes {
          label
          parentId
          url
          id
          databaseId
        }
      }
  }

    

      menubackgroundsEN: allWpMenubackground(
        filter: { locale: { id: { eq: "en_US" } } }
      ) {
        edges {
          node {
            featuredImage {
              node {
                altText
                sourceUrl
              }
            }
          }
        }
      }

      menubackgroundsAR: allWpMenubackground(
        filter: { locale: { id: { eq: "ar" } } }
      ) {
        edges {
          node {
            featuredImage {
              node {
                altText
                sourceUrl
              }
            }
          }
        }
      }

      menubackgroundsTR: allWpMenubackground(
        filter: { locale: { id: { eq: "tr_TR" } } }
      ) {
        edges {
          node {
            featuredImage {
              node {
                altText
                sourceUrl
              }
            }
          }
        }
      }

      menubackgroundsZHCN: allWpMenubackground(
        filter: { locale: { id: { eq: "zh_CN" } } }
      ) {
        edges {
          node {
            featuredImage {
              node {
                altText
                sourceUrl
              }
            }
          }
        }
      }
    }
  `);

  // const menulist = menuqry.menuAr;
  console.log(props,"props data lang");
  const menulist = props.lang==="en_US" ? menuqry.menuEn
      : props.lang==="ar" ? menuqry.menuAr
      : props.lang==="zh_CN" ? menuqry.menuZhcn : menuqry.menuEn

  // console.log(menulist,"menulist");
  // const menubackgroundslist = menuqry.menubackgroundsEN;

  const menubackgroundslist = props.lang==="en_US" ? menuqry.menubackgroundsEN
  : props.lang==="ar" ? menuqry.menubackgroundsAR
  : props.lang==="zh_CN" ? menuqry.menubackgroundsZHCN : menuqry.menubackgroundsEN

  const menubackgrounds =
    menubackgroundslist && menubackgroundslist.edges
      ? menubackgroundslist.edges
      : null;
  var menubg = menubackgrounds
    ? menubackgrounds[Math.floor(Math.random() * menubackgrounds.length)]
    : null;

  var menuItems =
    menulist && menulist.menuItems
      ? flatListToHierarchical(menulist.menuItems.nodes)
      : null;

  /**Initial states */
  const [isNavOpen, setIsNavOpen] = useState(false);
  // const [islanguageOpen, setIsLanguageOpen] = useState(false);

  useEffect(() => {
    const languageDropDown = document.getElementById("languageDropDown");
    languageDropDown?.addEventListener("shown.bs.dropdown", (event) => {
      // setIsLanguageOpen(true);
    });
    languageDropDown?.addEventListener("hidden.bs.dropdown", (event) => {
      // setIsLanguageOpen(false);
    });

    function handleClick() {
      // setIsLanguageOpen(false);
    }
    document.body.addEventListener("click", handleClick);

    Function.LoadingBootstrapScript();
    onPreRouteUpdate();
  }, []);

  const onPreRouteUpdate = () => {
    Function.LoadingBootstrapScript();
  };

  /**Handle mobile menu open */
  const handleMenuClick = () => {
    if (!isNavOpen) {
      setIsNavOpen(true);
      // document.body.style.overflow = "hidden";
    } else {
      closeMobileMenu();
    }
  };

  /**Handle mobile menu close */
  const closeMobileMenu = () => {
    setIsNavOpen(false);
    // document.body.style.overflow = "auto";
  };

  // const isActive = ({ isCurrent }) => {
  //   return isCurrent ? { className: "active-link" } : {};
  // };

  const isPreviewMode = process.env.GATSBY_PREVIEW_MODE === "true";
  console.log(props.translations,"props.translations props.translations props.translations")
  const language = LangConfig[props.lang]["slug"];
  return (
    <>
      <div
        className={`header-wrapper ${props.isAboveRefPoint ? "" : "header-blue-bg"}`}
      >
        <div className="container">
          <div className="header">
            <div className="logo-nav">
              <div className="logo-container">
                <Link to={`/${language}/`}>
                  <img
                    className="jameel-motors-logo"
                    alt="Jameel Motors"
                    src={
                      props.isAboveRefPoint ? jameelMotorsLogo : jameelMotorsLogoBlue
                    }
                    width={95}
                    height={78}
                  />
                </Link>
              </div>
              <div
                className={isNavOpen ? "nav-options active" : "nav-options"}
                style={{
                  background: `url(${menubg && menubg.node
                    ? menubg.node.featuredImage.node.sourceUrl
                    : "https://media.aljhealth.com/wp-content/uploads/2022/07/28071758/background-two-try.jpg"
                    })`,
                }}
              >
                {/* <div className="position-relative h-100"> */}
                {/* <div className="position-absolute arabic-menu-container">
                    <div
                      className={`mobile-menu ${isNavOpen ? "mobile-menu-open" : ""}`}
                      ref={burgerMenuIconRef}
                      onClick={handleMenuClick}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === 'Space') {
                          handleMenuClick()

                        }
                      }}
                    >
                      <img
                        className="menu-icon"
                        alt="Jameel Motors"
                        src={closeBlue}
                      />
                    </div>
                  </div> */}
                <ul
                  className="d-flex flex-column align-items-start nav-options-wrapper"
                  ref={navMenuRef}
                >
                  {menuItems
                    ? menuItems.map((item, index) =>
                      item.children.length > 0 ? (
                        <li
                          key={index}
                          className="option font-md flex-column flex-sm-row justify-content-between align-items-start"
                        >
                          <Link
                            to={`${item.url
                              .replace("/home/", "")
                              .replace("//", "/") === "#"
                              ? "#/"
                              : ""
                              }`}
                            key={item.key}
                            title={item.label}
                            className={`menu-${item.databaseId} ${item.children.length > 0 ? "" : "menu-no-bg"
                              } mainmenu mainMenuClick d-flex align-items-center justify-content-between w-100`}
                          >
                            {item.label}
                            <img
                              src={rightArrowWhite}
                              alt="Jameel motors"
                              className="sub-options-arrow"
                            />
                          </Link>
                          <ul className="d-flex flex-column justify-content-start sub-options-wrapper font-smmd">
                            {item.children.map((chld, index) => (
                              <li
                                key={index}
                                onClick={closeMobileMenu}
                                className="parent-nav-options font-md"
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter' || e.key === 'Space') {
                                    closeMobileMenu();
                                    // Your additional logic here
                                  }
                                }}
                                role="button"
                                tabIndex={0}
                              >
                                <Link
                                  to={`/${LangConfig[props.lang]["slug"]}/${chld.url
                                    .replace("/home/", "")
                                    .replace("/", "")}`}
                                  key={chld.label}
                                  title={chld.label}
                                  className={`menu-${chld.databaseId} sub-options`}
                                >
                                  {chld.label}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </li>
                      ) : (
                        <li
                          key={index}
                          className="option font-md parent-nav-options"
                          onClick={closeMobileMenu}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === 'Space') {
                              closeMobileMenu();
                              // Your additional logic here
                            }
                          }}
                          role="button"
                          tabIndex={0}
                        >
                          <Link
                            to={`/${LangConfig[props.lang]["slug"]}${item.url
                              .replace("/home/", "")
                              .replace("//", "/")}`}
                            key={index}
                            title={item.label}
                            className={`menu-${item.databaseId} parentmenu menu-no-bg option`}
                          >
                            {item.label}
                          </Link>
                        </li>
                      )
                    )
                    : null}
                  <li className="option font-md flex-column flex-sm-row justify-content-between align-items-start language-nav-option">
                    <a className="d-flex align-items-center justify-content-between w-100">
                      <img src={earth} alt="Jameel Motors" />
                      <img src={rightArrowWhite} alt="Jameel motors" className="sub-options-arrow" />
                    </a>
                    <ul className="d-flex flex-column justify-content-start  sub-options-wrapper parent-nav-options font-smmd">
                      {/* <Link to="" className="sub-options">English</Link>
                      <Link to="" className="sub-options">العربية</Link>
                      <Link to="" className="sub-options">日本語</Link>
                      <Link to="" className="sub-options">中国语文</Link>
                      <Link to="" className="sub-options">Français</Link>
                      <Link to="" className="sub-options">Español</Link>
                      <Link to="" className="sub-options">Türkçe</Link> */}
                     
                      

                     {props.translations && props.translations.length > 0 ? (
    <>
        {props.translations.map((item, key) => (
            item.publishStatus.status !== "private" ? (
                <li
                    key={key}
                    className={item.locale.id === "ar" ? "arabic_lang" : "english-lang"}
                    onClick={closeMobileMenu}
                >
                    {LangConfig[item.locale.id] ? (
                        <Link
                            to={item.localizedWpmlUrl.replace("home/", "")}
                            className={`menu-lang-child`}
                        >
                            {LangConfig[item.locale.id]["text"]}
                        </Link>
                    ) : null}
                </li>
            ) : null
        ))}
    </>
) : null}


                        {/* {isPreviewMode ?
                        props.translations && props.translations.length > 0 ? (
                        props.translations.map((item, index) => (
                           
                            <li
                              key={index}
                              className={item.locale.id === "ar" ? 'arabic_lang' : 'english-lang'}
                              onClick={closeMobileMenu}
                            >
                              {LangConfig[item.locale.id] && (
                                <Link
                                  to={item.localizedWpmlUrl.replace('home/', '')}
                                  className="menu-lang-child"
                                >
                                  {LangConfig[item.locale.id].text}
                                </Link>
                              )}
                            </li>
                        ))
                      ) : null
                    :

                    props.translations && props.translations.length > 0 ? (
                      props.translations.map((item, index) => (
                         item.publishStatus.status === "publish" ? (
                          <li
                            key={index}
                            className={item.locale.id === "ar" ? 'arabic_lang' : 'english-lang'}
                            onClick={closeMobileMenu}
                          >
                            {LangConfig[item.locale.id] && (
                              <Link
                                to={item.localizedWpmlUrl.replace('home/', '')}
                                className="menu-lang-child"
                              >
                                {LangConfig[item.locale.id].text}
                              </Link>
                            )}
                          </li>)
                          : null
                        
                      ))
                    ) : null
                    } */}

{/* {props.translations && props.translations.length > 0 ? (
                      props.translations.map((item, index) => (
                         item.publishStatus.status === "publish" ? (
                          <li
                            key={index}
                            className={item.locale.id === "ar" ? 'arabic_lang' : 'english-lang'}
                            onClick={closeMobileMenu}
                          >
                            {LangConfig[item.locale.id] && (
                              <Link
                                to={item.localizedWpmlUrl.replace('home/', '')}
                                className="menu-lang-child"
                              >
                                {LangConfig[item.locale.id].text}
                              </Link>
                            )}
                          </li>)
                          : null
                        
                      ))
                    ) : null
                    } */}

                    </ul>
                  </li>
                </ul>
                {/* </div> */}
              </div>
            </div>
            <div className="menu-icon-search-wrapper">
              <div
                className="location-search-container"
                data-bs-toggle="modal"
                data-bs-target="#searchmodal"
              >
                {/* <div className="dropdown">
                  <a
                    className={`location-search-icon ${props.isAboveRefPoint ? islanguageOpen ? "language-drop-down-open" : "language-drop-down-close" : islanguageOpen ? "language-drop-down-close-teal" : ""}`}
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    data-bs-hide={false}
                    data-bs-auto-close="true"
                    id="languageDropDown"
                  >
                    <img
                      alt="Jameel Motors"
                      src={props.isAboveRefPoint ? islanguageOpen ? earthBlue : earth : islanguageOpen ? earth : earthBlue}
                      width={20}
                      height={20}
                    />
                  </a>
                  <ul className="dropdown-menu"
                  >
                    <li>
                      <a
                        className="dropdown-item language-drop-down-list"
                        href=""
                      >
                        English
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item language-drop-down-list"
                        href=""
                      >
                        العربية
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item language-drop-down-list"
                        href=""
                      >
                        日本語
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item language-drop-down-list"
                        href=""
                      >
                        中国语文
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item language-drop-down-list"
                        href=""
                      >
                        Français
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item language-drop-down-list"
                        href=""
                      >
                        Español
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item language-drop-down-list"
                        href=""
                      >
                        Türkçe
                      </a>
                    </li>
                  </ul>
                </div> */}
                {/* <img
                  className="location-search-icon"
                  alt="Jameel Motors"
                  src={location}
                  width={20}
                  height={20}
                /> */}
                <div className="location-search">
                  <img
                    alt="Jameel Motors"
                    src={props.isAboveRefPoint ? search : searchBlue}
                    width={20}
                    height={20}
                  />
                </div>
              </div>
              <GlobalSearch lang={props.lang} />
              <div
                className={`mobile-menu ${isNavOpen ? "mobile-menu-open" : ""}`}
                ref={burgerMenuIconRef}
                onClick={handleMenuClick}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === 'Space') {
                    handleMenuClick()

                  }
                }}
              >
                <img
                  className="menu-icon"
                  alt="Jameel Motors"
                  src={
                    isNavOpen
                      ? closeBlue
                      : props.isAboveRefPoint
                        ? burgerIcon
                        : menuBlue
                  }
                />
              </div>
            </div>
          </div>
          <div className="pagescrollbar">
            <div className="progressbar"></div>
          </div>
        </div>
      </div>
    </>
  );
}
